import { render, staticRenderFns } from "./print.vue?vue&type=template&id=22ac6612&"
import script from "./print.vue?vue&type=script&lang=js&"
export * from "./print.vue?vue&type=script&lang=js&"
import style0 from "./print.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/unknown/projects/pts/clinicmis-master/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VFlex,VIcon,VLayout})
